import { RootState } from 'store/rootReducer';

export const LogoutContentSelector = (state: RootState) => state.content.logout;
